import React from "react";
import { Badge } from "@/components/ui/badge";
import { Check, Loader2, AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

interface AutoSaveIndicatorProps {
  status: SaveStatus;
  className?: string;
}

export function AutoSaveIndicator({ status, className }: AutoSaveIndicatorProps) {
  if (status === 'idle') return null;

  return (
    <Badge
      variant="outline"
      className={cn(
        "transition-all duration-300",
        status === 'saved' && "text-chart-5 border-chart-5/30 bg-chart-5/5",
        status === 'saving' && "text-muted-foreground border-muted",
        status === 'error' && "text-destructive border-destructive/30 bg-destructive/5",
        className
      )}
    >
      {status === 'saving' && (
        <>
          <Loader2 className="h-3 w-3 mr-1 animate-spin" />
          Speichert...
        </>
      )}
      {status === 'saved' && (
        <>
          <Check className="h-3 w-3 mr-1" />
          Gespeichert
        </>
      )}
      {status === 'error' && (
        <>
          <AlertCircle className="h-3 w-3 mr-1" />
          Fehler
        </>
      )}
    </Badge>
  );
}
